"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var TitleState =
/*#__PURE__*/
function () {
  function TitleState() {
    _classCallCheck(this, TitleState);
  }

  _createClass(TitleState, null, [{
    key: "getState",
    value: function getState(media, patronItems) {
      var featureManager = window.featureManager;

      if (featureManager.isEnabled('internationalDemoMode')) {
        return 'preview';
      }

      var mediaId = media.id;
      var isOnHold = patronItems && patronItems.onHolds.indexOf(mediaId) > -1;
      var isOnCheckouts = patronItems && patronItems.onCheckouts.indexOf(mediaId) > -1;
      var isOnRecommendations = patronItems && patronItems.recommendedToLibrary.indexOf(mediaId) > -1 || media.isRecommended;
      var isAvailable = media.isAvailable || featureManager.isEnabled('LuckyDay') && media.luckyDayAvailableCopies > 0;

      if (/account\/loans/.test(window.location.href) && media.isRenewable && featureManager.isEnabled('content-holds')) {
        if (isOnHold) {
          return 'requested';
        } else if (media.holdsCount <= 0 && media.ownedCopies >= 0 && !(featureManager.isEnabled('LuckyDay') && media.isLuckyDayCheckout) && featureManager.isEnabled('renewTitles')) {
          return 'renew';
        }

        return 'requestAgain';
      }

      if (isOnCheckouts) {
        return 'borrowed';
      }

      if (isOnHold && !isAvailable) {
        return 'onHold';
      }

      if (isOnRecommendations && !isAvailable && !media.isHoldable) {
        return 'recommended';
      }

      if (isAvailable) {
        if (media.type.id === 'periodicals') {
          return 'nook';
        }

        return 'borrow';
      }

      if (!media.isOwned && media.isRecommendableToLibrary && featureManager.isEnabled('recommend-to-library')) {
        return 'recommend';
      }

      if (media.isHoldable && featureManager.isEnabled('content-holds')) {
        return 'hold';
      }

      return 'unavailable';
    }
  }, {
    key: "isOnWishlist",
    value: function isOnWishlist(media, patronItems) {
      return patronItems && patronItems.onWishlist.indexOf(media.id) > -1;
    }
  }, {
    key: "isOnReadingHistory",
    value: function isOnReadingHistory(media, patronItems) {
      return patronItems && patronItems.onReadingHistory.indexOf(media.id) > -1;
    }
  }, {
    key: "starRating",
    value: function starRating(media, patronItems) {
      // Returns 0 if not rated
      return patronItems && patronItems.starRatings && patronItems.starRatings[media.id] || 0;
    }
  }]);

  return TitleState;
}();

var _default = TitleState;
exports["default"] = _default;